import { jsx as _jsx } from "react/jsx-runtime";
const LosseFlexShell = ({ fields, index, types }) => {
    if (!fields.styletype || !types[fields.styletype]) {
        return null;
    }
    const Component = types[fields.styletype];
    return _jsx(Component, { index: index, fields: fields }, index);
};
export default LosseFlexShell;
